import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Rating } from "react-simple-star-rating";
import { toast } from "react-toastify";
import no_reviews from "../../../assets/no_reviews.svg";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { postRequestcall } from "../../comman/util/postRequest";
import { PRODUCTRATING_LIST } from "../../constants/apiurl";
import ReviewListPage from "../../comman/components/ReviewListPage";
import ButtonPage from "../../comman/button/ButtonPage";
import ProductaddreviewPage from "./ProductaddreviewPage";

function RattingPage(props) {

  let getpid = window.location.pathname.split("/").pop();
  const { t } = useTranslation();
  const [productreview, setProductreview] = useState(false);
  const [reviewlist, setReviewlist] = useState([]);
  const [noreview, setNoreview] = useState(false);
  const [previewList, setPreviewList] = useState(3)
  const showReview = () => {
    if (props.access_token) {
      setProductreview(true);
    } else {
      toast.error(t("pages.Please login"));
    }
  };

  // eslint-disable-next-line
  useEffect(() => {
    (async () => getRating(1, false))();
    // eslint-disable-next-line
  }, []);

  const getRating = async (page, bind) => {
    let geturl = PRODUCTRATING_LIST + `?product_id=${getpid}&page=${page}`;
    let productRatingResponse = await postRequestcall(
      geturl,
      props?.access_token
    );
    if (productRatingResponse?.status === 200) {
      let response = await productRatingResponse.json();
      if (response?.data?.data?.length === 0) {
        setNoreview(true);
        setReviewlist([]);
      } else {
        setNoreview(false);
        if (bind) {
          setReviewlist(reviewlist.concat(response?.data?.data));
        } else {
          setReviewlist(response?.data?.data);
        }
      }
    } else {
      setNoreview(true);
      setReviewlist([]);
    }
  };

  return (
    <>
      <div className="customer_review review-common mt-3">
        <div className="review_add pb-2">
          <div>
            <h5 className="mb-0">{t("pages.Customer reviews")}</h5>
            <label>
              <Rating
                initialValue={Number(props?.productDetail?.rating_ratio)}
                readonly={true}
                size={17}
                fillColor={"var(--pr-color)"}
              />
              <span>
                {props?.language === "Tr"
                  ? `5 ${t("pages.out of")} ${Number(
                      props?.productDetail?.rating_ratio
                    )}`
                  : ` ${Number.parseFloat(props?.productDetail?.rating_ratio).toFixed(1)} ${t(
                      "pages.out of"
                    )} 5`}
              </span>
            </label>
          </div>
          <ButtonPage
           className={"button-submit add-review"}
           Text={t("pages.Add review")}
           onClick={() => showReview()}
          />
        </div>
          {noreview ? (
            <div className="no_review">
              <LazyLoadImage
                alt=""
                style={{ width: "150px" }}
                src={no_reviews}
              />
              <h5 className="mt-3" style={{ fontSize: "17px" }}>
                {t("pages.No review found")}
              </h5>
            </div>
          ) : (
            <div
              id="offernotiscrollableDiv"
            >
              <Row>
                {reviewlist?.map((item, index) => previewList > index && (
                  <Col lg={12} sm={12} md={12} xl={12} key={index.toString()}  >
                    <ReviewListPage  item={item}/>
                  </Col>
                ))}
                {
                  reviewlist?.length > previewList && (
                    <ButtonPage
                      Text={t("pages.Read More")}
                      className={"button-black w-auto mx-auto"}
                      onClick={()=>setPreviewList(previewList + 5)}
                    />
                  ) 
                }
              </Row>
            </div>
          )}
      </div>
      {productreview && (
        <ProductaddreviewPage
          productreview={productreview}
          setProductreview={setProductreview}
          productDetail={props.productDetail}
          getRating={getRating}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps)(RattingPage);
